<template>
    <header class="relative">
        <SlideDownTransition>
            <div class="header-bar spacing-alternative">
                <div class="ws-controls flex items-start">
                    <div class="button-group flex gap-1 items-center">
                        <button 
                            class="button button-bordered cta--menu-icon"
                            :class="menuState && 'close-icon'"
                            v-touch:tap="toggleRoutine"
                        >
                            <span></span>
                        </button>
                        <CrossFadeTransition :show ="!visible">
                            <PodcastMediaBar v-if="globalPlayerState" :trackID=1></PodcastMediaBar>
                        </CrossFadeTransition>
                    </div>
                </div>
                <SlideDownTransition>
                    <NuxtLink 
                        v-if="!menuState"
                        :to="localePath('/')"
                        class="page-header-logo"
                        :class="layout === 'layout-2' && 'geeks-logo-container'"
                    >
                        <MediaElement 
                            :src="layout !== 'layout-2' ? '/ws-logo-basic.svg' : '/backseat_geeks_weiss.svg'" 
                            :alt="'W-S Logo'" 
                            :classes="
                                (pageContent[pageID]?.pagecontent.background_color === 'light-sand') ||
                                (pageContent[pageID]?.pagecontent.background_color === 'dark-blue') ||
                                !pageID ? 
                                'logo ux-element' : 
                                'logo ux-element logo-dark'"
                            >
                        </MediaElement>
                    </NuxtLink>
                </SlideDownTransition>

            </div>
        </SlideDownTransition>
    </header>
</template>

<script setup lang="ts">
    import { MathHelper } from "~/composables/Classes/Helper";
    import { useRequestStore } from '@/stores/requests';
    import { useGlobalsStore } from "@/stores/globals";
    import { useMedia } from '@/stores/media'

    const props = defineProps<{
        layout: string
    }>()

    const localePath = useLocalePath()
    const route = useRoute()

    const requestStore = useRequestStore()
    const globalsStore = useGlobalsStore()
    const mediaStore = useMedia()
    const { $iframeMessenger } = useNuxtApp()
    
    const { pageContent, pageID } = storeToRefs(requestStore)
    const { menuState, globalPlayerState } = storeToRefs(globalsStore)
    const { playerState, isVisible } = storeToRefs(mediaStore)

    const mobileButton = ref<boolean>(false)
    const visible = computed(() => isVisible.value)

    const stageExpStarted = ref<boolean>(true)

    const toggleRoutine = <Function>() => {
        const menu = document.querySelector('.main-menu') as HTMLElement;
        menuState.value === true ? globalsStore.changeMenuState(false) : globalsStore.changeMenuState(true)
    }

    const initialize = <Function>() => {
        nextTick(() => {
            window.onscroll = () => {
                const headerLink = document.querySelector('header .page-header-logo') as HTMLElement;

                if (scrollY > 30) {
                    MathHelper.mutateEle(headerLink, 'add-class', 'hide')
                    MathHelper.mutateEle(headerLink, 'add-class', '-translate-y-[170%]')
                } else {
                    MathHelper.mutateEle(headerLink, 'remove-class', 'hide')
                    MathHelper.mutateEle(headerLink, 'remove-class', '-translate-y-[170%]')
                }
            }
        })
    }

    const resizeObserver = new ResizeObserver((entries) => {
        const windowWidth = window.innerWidth;

        if (windowWidth >= 1440) {
            mobileButton.value = false
        } else {
            mobileButton.value = true
        }
    });

    resizeObserver.observe(document.body);

    watch(
        () => route.path,
        (newRoute) => {
			if (newRoute === '/de/' || newRoute === '/en/') {
                stageExpStarted.value = false
            } else {
                stageExpStarted.value = true
            }
        }
    )

    onMounted(() => {
        initialize()

        if (route.path === '/de/' || route.path === '/en/') {
            stageExpStarted.value = false
        }

        $iframeMessenger.on('experienceStart', (payload: boolean) => {
            stageExpStarted.value = payload
        })
    })
</script>
